import { Button, Grid, styled } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import "./ImageInput.css";
import CustomButton from "components/CustomButton";
import theme from "config/theme";
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


const ImageInput = ({ nameInput, iconImage, imageSrc, onChange, dark = false }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handlerChange = (e) => {
    const image = e.target.files && e.target.files[0];
    if (!image) return;
    onChange && onChange(image);
    setSelectedImage(URL.createObjectURL(image));
  };

  useEffect(() => {
    imageSrc && setSelectedImage(imageSrc && `/v3/file/${imageSrc}/`);
    // eslint-disable-next-line
  }, []);

  return (
    <Grid
      container
      item
      xs={8}
      direction="column"
      justifyContent={"center"}
      style={{ width: "100%" }}
      className="container-image-icon"
    >
      <Grid justifyContent={"space-around"} style={{ display: "flex" }}>
        {selectedImage && (
          <img
            alt=""
            className="image-icon"
            src={selectedImage}
          />
        )}
      </Grid>
      <Grid justifyContent={"space-around"} style={{ display: "flex" }} mt={2}>
        <Button
          component="label"
          role={undefined}
          startIcon={<CloudUploadIcon />}
          sx={{
            textTransform: 'none',
            backgroundColor: theme.button[dark ? 'dark' : 'light'].backgroundColor,
            color: theme.button[dark ? 'dark' : 'light'].color,
            height: '40px',
            minWidth: '150px',
            borderRadius: '25px',
            padding: '0 32px',
            fontWeight: 'bold',
            fontSize: '18px',
            border: theme.button[dark ? 'dark' : 'light'].border,
            '&:disabled': {
              border: theme.button[dark ? 'dark' : 'light'].border,
              backgroundColor: theme.button[dark ? 'dark' : 'light'].backgroundColor,
              color: theme.button[dark ? 'dark' : 'light'].color,
            }
          }}
        >
          {`Subir ${nameInput}`}
          <VisuallyHiddenInput
            type="file"
            onChange={handlerChange}
          />
        </Button>
      </Grid>
    </Grid>
  );
};

export default ImageInput;
